import { render, staticRenderFns } from "./BoxesModal.vue?vue&type=template&id=0b790611&scoped=true&"
import script from "./BoxesModal.vue?vue&type=script&lang=js&"
export * from "./BoxesModal.vue?vue&type=script&lang=js&"
import style0 from "./BoxesModal.vue?vue&type=style&index=0&id=0b790611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b790611",
  null
  
)

export default component.exports